import { pageInstanceId } from 'atc-js';

// Generated by GitHub Copilot
// Generate once and cache to prevent re-renders
let cachedPgInstanceId = null;
export const pgInstanceId = cachedPgInstanceId || (cachedPgInstanceId = pageInstanceId.getRandomId());
